<ion-item>
  <ion-button slot="start" (click)="previousPage()" disabled="{{this.disableBack}}">
    <ion-icon slot="icon-only" name="caret-back-outline"></ion-icon>
  </ion-button>

  <ion-label id="pagina">Página {{CurrentPage}}</ion-label>

  <ion-button slot="end" (click)="nextPage()" disabled="{{this.disableForth}}">
    <ion-icon slot="icon-only" name="caret-forward-outline"></ion-icon>
  </ion-button>
</ion-item>
